import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-coordinate-mask-type',
  templateUrl: './coordinate-mask-type.component.html',
  styleUrls: ['./coordinate-mask-type.component.scss']
})
export class CoordinateMaskTypeComponent extends FieldType {}
